import React from 'react';
import useSelector from 'modules/default-selector';
import { featuresUsingClaims } from '../features';

export const useFeatures = () => {
  const userClaims = useSelector(state => state.user.claims);
  return React.useMemo(() => featuresUsingClaims(userClaims), [userClaims]);
};
